import {useId} from 'react';

import BackButton from '@/components/BackButton/BackButton';
import {ArrowLeftIcon} from '@/components/Icons';

import {useRescheduleFlow} from '../RescheduleFlowContext';
import RescheduleCalendar from './RescheduleCalendar';
import RescheduleCalendarConfirmButton from './RescheduleCalendarConfirmButton';
import RescheduleFrequencyStep from './RescheduleFrequencyStep';

const RescheduleDesktopSlideLayout = ({onBack, children}: {onBack: () => void; children: React.ReactNode}) => (
    <div className='relative flex min-h-full flex-col gap-8'>
        {/* @ts-ignore */}
        <BackButton onClick={onBack} icon={<ArrowLeftIcon />} />
        {children}
    </div>
);

const RescheduleDesktopFrequencySlide = () => {
    const popupTitleId = useId();
    const {hasFrequencyStep, handleFrequencySelect, handleBack} = useRescheduleFlow();

    if (!hasFrequencyStep) {
        return null;
    }

    return (
        <RescheduleDesktopSlideLayout onBack={handleBack}>
            <RescheduleFrequencyStep onSelectFrequency={handleFrequencySelect} titleId={popupTitleId} />
        </RescheduleDesktopSlideLayout>
    );
};

const RescheduleDesktopCalendarSlide = () => {
    const popupTitleId = useId();
    const {selectedDate, handleDateSelect, handleCalendarConfirm, handleBack} = useRescheduleFlow();

    return (
        <RescheduleDesktopSlideLayout onBack={handleBack}>
            <RescheduleCalendar
                selectedDate={selectedDate}
                onDateSelect={handleDateSelect}
                onConfirm={handleCalendarConfirm}
                titleId={popupTitleId}
                hideConfirmButton
            />
        </RescheduleDesktopSlideLayout>
    );
};

export const RescheduleInlineFooter = () => {
    const {selectedDate, handleCalendarConfirm} = useRescheduleFlow();

    return <RescheduleCalendarConfirmButton selectedDate={selectedDate} onConfirm={handleCalendarConfirm} />;
};

export {RescheduleDesktopCalendarSlide, RescheduleDesktopFrequencySlide};
